import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { EffectsModule } from '@ngrx/effects';
import { CommonModule } from '@angular/common';
import { ModuleWithProviders } from '@angular/core';

import { AgentEffects } from './agent/agent.effects';
import { agentReducer } from './agent/agent.reducer';
import { securityReducer } from './security/security.reducer';

@NgModule({
  imports: [
    CommonModule,
    StoreModule.forRoot({
      agent: agentReducer,
      securityAvailable: securityReducer,
    }),
    EffectsModule.forRoot([AgentEffects]),
  ],
})
export class StoreManagementModule {
  static forRoot(): ModuleWithProviders<StoreManagementModule> {
    return {
      ngModule: StoreManagementModule,
      providers: [],
    };
  }
}
